import React from 'react';

import { TFunction, useTranslation } from 'react-i18next';

import DropdownField from 'components/form-fields/formik/DropdownField';
import { TimeUnit, TimeUnitValues } from 'subdomains/cpo/types/charging-policy';
import { DropdownOption } from 'subdomains/cpo/types/form';

export const TimeFormatField = (props: {
  name: string;
  required?: boolean;
  wrapperStyle?: React.CSSProperties;
}) => {
  const { t } = useTranslation();

  return (
    <DropdownField
      name={props.name}
      selection
      clearable={false}
      required={props.required}
      label={t('operator.timeFormatFieldLabelText', 'Format')}
      defaultValue="HOUR"
      options={getTimeFormatOptions()}
      wrapperStyle={props.wrapperStyle}
    />
  );
};

const getTimeFormatOptions = (): DropdownOption<TimeUnit>[] => {
  const { t } = useTranslation();

  return TimeUnitValues.map((value) => ({
    key: value,
    value,
    text: getTimeFormatLabel(t, value),
  }));
};

export function getTimeFormatLabel(
  t: TFunction<'translation', undefined>,
  timeFormat: TimeUnit
): string {
  switch (timeFormat) {
    case TimeUnit.HOUR:
      return t('timeFormatField.options.hour', 'Hour');
    case TimeUnit.MINUTE:
      return t('timeFormatField.options.minute', 'Minute');
    default:
      return '';
  }
}
